window.Vue = require('vue');

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

Vue.component('formulario-contacto', require('../../componentes/sitio/FormularioContactoProyecto').default);

Vue.config.productionTip = false;
Vue.config.devtools = false;

if(document.getElementById("vue-contacto")){
    const contacto = new Vue({
        el: '#vue-contacto',
    });
}
